__turbopack_context__.v({
  "bazaarvoice-review-success-modal": "bazaarvoice-review-success-modal-component-module-scss-module__sD9j-G__bazaarvoice-review-success-modal",
  "bazaarvoice-review-success-modal__body": "bazaarvoice-review-success-modal-component-module-scss-module__sD9j-G__bazaarvoice-review-success-modal__body",
  "bazaarvoice-review-success-modal__icon": "bazaarvoice-review-success-modal-component-module-scss-module__sD9j-G__bazaarvoice-review-success-modal__icon",
});
